export default "__VITE_ASSET__CKlu8kFk__"